import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/ChangePasswordPage.css';
import logo from '../assets/elon_logo.png';

function ChangePasswordPage() {
  const [nuevaPass, setNuevaPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('resetToken');
    if (!token) {
      setError('No tienes token para restablecer la contraseña. Verifica tu token primero.');
      navigate('/login'); 
    }
  }, [navigate]);

  // Función de validación
  const validateForm = () => {
    const errors = {};
    
    // Validación de nuevaPass
    if (!nuevaPass.trim()) {
      errors.nuevaPass = 'La contraseña es requerida';
    } else if (nuevaPass.length < 8) {
      errors.nuevaPass = 'La contraseña debe tener al menos 8 caracteres';
    }
    
    // Validación de confirmPass
    if (!confirmPass.trim()) {
      errors.confirmPass = 'La confirmación de contraseña es requerida';
    } else if (confirmPass.length < 8) {
      errors.confirmPass = 'La confirmación de contraseña debe tener al menos 8 caracteres';
    } else if (nuevaPass !== confirmPass) {
      errors.confirmPass = 'Las contraseñas no coinciden';
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    setFormErrors({});
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const t = localStorage.getItem('resetToken');
    if (!t) {
      setError('Falta el token para cambiar la contraseña.');
      return;
    }

    try {
      await api.post(`/auth/reset-password/${t}`, {
        nuevaContraseña: nuevaPass
      });
      await alertService.success(
        'Contraseña Cambiada',
        '¡Contraseña restablecida con éxito! Redirigiendo a login...'
      );
      localStorage.removeItem('resetToken');  

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      let errorMessage = 'Error al cambiar la contraseña o token inválido/expirado.';
      
      if (err.response && err.response.data && err.response.data.error) {
        errorMessage = err.response.data.error;
      }
      
      await alertService.error('Error', errorMessage);
    }
  };

  // Elimina el token y redirige al login
  const handleCancel = () => {
    localStorage.removeItem('resetToken');
    navigate('/login');
  };

  return (
    <div className="change-password-bg">
      <div className="change-password-card">
        <img 
          src={logo} 
          alt="Elon School Logo" 
          className="change-password-logo"
          loading="lazy"
        />
        <h2 className="change-password-title">Cambiar Contraseña</h2>
        
        {/* Mensaje de error o éxito general */}
        {error && <p className="change-password-error-message">{error}</p>}
        {mensaje && <p className="change-password-success-message">{mensaje}</p>}
        
        {!mensaje && (
          <form onSubmit={handleSubmit}>
            {/* Campo: Nueva Contraseña */}
            <div className="change-password-form-group">
              <label>Nueva Contraseña:</label>
              <input
                type="password"
                value={nuevaPass}
                onChange={(e) => setNuevaPass(e.target.value)}
                placeholder="Ingresa tu nueva contraseña"
              />
              {formErrors.nuevaPass && (
                <span className="course-error-message">{formErrors.nuevaPass}</span>
              )}
            </div>
            
            {/* Campo: Confirmar Contraseña */}
            <div className="change-password-form-group">
              <label>Confirmar Contraseña:</label>
              <input
                type="password"
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
                placeholder="Confirma tu nueva contraseña"
              />
              {formErrors.confirmPass && (
                <span className="course-error-message">{formErrors.confirmPass}</span>
              )}
            </div>
            
            <div className="change-password-button-group">
              <button type="button" className="change-password-btn-back" onClick={handleCancel}>
                Cancelar
              </button>
              <button type="submit" className="change-password-btn-submit">
                Cambiar Contraseña
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ChangePasswordPage;